<section class="hc-hero">
  <div class="hc-hero-inner">
    <h1>EasyEviction Help Center</h1>
    <form class="hc-hero-search" (ngSubmit)="onSearch()">
      <mat-icon>search</mat-icon>
      <input
        type="search"
        name="q"
        placeholder="Search for articles…"
        aria-label="Search for articles"
        [(ngModel)]="query"
      />
    </form>
  </div>
</section>

<ee-help-home (openCollection)="openCollection($event)"></ee-help-home>
